import moment from "moment";

// Alphabetical sorting (case-insensitive)
export const sortAlphabetically = (a, b, field) => {
  const valueA = (a[field] || "").toLowerCase();
  const valueB = (b[field] || "").toLowerCase();
  return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
};

// Numeric sorting
export const sortNumerically = (a, b, field) => {
  const valueA = parseInt(a[field]) || 0;
  const valueB = parseInt(b[field]) || 0;
  return valueA - valueB;
};

// Date sorting using moment
export const sortByDate = (a, b, field) => {
  if (!a[field] && !b[field]) return 0;
  if (!a[field]) return 1;
  if (!b[field]) return -1;
  return moment(a[field]).unix() - moment(b[field]).unix();
};

// Date sorting for MM/DD/YYYY or MM/DD/YYYY z (with timezone suffix) format
export const sortByFormattedDate = (a, b, field) => {
  if (!a[field] && !b[field]) return 0;
  if (!a[field]) return 1;
  if (!b[field]) return -1;

  const parseDate = (dateStr) => {
    const [month, day, yearPart] = dateStr.split("/");
    const year = yearPart ? yearPart.trim().split(" ")[0] : "";
    return new Date(year, month - 1, day);
  };

  return parseDate(a[field]) - parseDate(b[field]);
};

// Standard sort directions for Ant Design tables
export const SORT_DIRECTIONS = ["ascend", "descend"];
